import SessionService from "./session";

const axios = require("axios").default;

const baseUrl =
  process.env.VUE_APP_IS_STANDALONE === "false"
    ? "/"
    : process.env.VUE_APP_BASE_URL;

const tokenBearer = SessionService.isLogged()
  ? `Bearer ${SessionService.session().token}`
  : undefined;

const http = axios.create({
  baseURL: baseUrl,
  timeout: 5 * 60 * 1000,
  timeoutErrorMessage: "No connection with resources",
  headers: {
    authorization: tokenBearer,
    common: {
      Accept: "application/json"
    }
  }
});

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const { pathname } = location;
    if (error.response.status === 401) {
      if (pathname !== "/signin" || !pathname.startsWith("/confirm")) {
        SessionService.logout();
      }
    }
    return Promise.reject(error);
  }
);

export default http;
